import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useClinicTheme } from "../../../theme";
import { COLORS } from "../../../styles/uiConstants";

/**
 * Sayaç rozetli filtre sekmeleri. Dropdown yerine tek tıkla filtre + sayıyı
 * aynı anda gösterir. Vurgu rengi klinik temasından gelir.
 *
 * @param {Array<{id: string, label: string, icon?: React.ReactNode, count?: number}>} filters
 */
export default function FilterTabs({
  filters = [],
  activeFilter,
  onChange,
  isLoading = false,
}) {
  const { palette } = useClinicTheme();

  return (
    <Box
      role="tablist"
      sx={{
        display: "flex",
        gap: 1,
        overflowX: "auto",
        pb: 0.5,
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {filters.map((f) => {
        const isActive = f.id === activeFilter;
        return (
          <Box
            key={f.id}
            component="button"
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange?.(f.id)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.75,
              flexShrink: 0,
              px: 1.75,
              py: 0.875,
              borderRadius: 2,
              cursor: "pointer",
              fontFamily: "inherit",
              fontSize: "0.8125rem",
              fontWeight: 600,
              whiteSpace: "nowrap",
              border: `1px solid ${isActive ? palette.primary : COLORS.slate200}`,
              bgcolor: isActive ? palette.primary : COLORS.white,
              color: isActive ? palette.contrastText : COLORS.slate600,
              transition: "all .15s ease",
              "&:hover": {
                bgcolor: isActive ? palette.primaryDark : alpha(palette.primary, 0.08),
                borderColor: palette.primary,
              },
            }}
          >
            {f.icon || null}
            <span>{f.label}</span>
            {f.count != null ? (
              isActive && isLoading ? (
                <CircularProgress size={12} sx={{ color: palette.contrastText }} />
              ) : (
                <Box
                  component="span"
                  sx={{
                    minWidth: 22,
                    px: 0.75,
                    py: 0.125,
                    borderRadius: 1,
                    fontSize: "0.6875rem",
                    fontWeight: 700,
                    bgcolor: isActive
                      ? alpha(palette.contrastText, 0.22)
                      : COLORS.slate100,
                    color: isActive ? palette.contrastText : COLORS.slate600,
                  }}
                >
                  {f.count}
                </Box>
              )
            ) : null}
          </Box>
        );
      })}
    </Box>
  );
}
